import { render, staticRenderFns } from "./NewPay.vue?vue&type=template&id=02343926&scoped=true&"
import script from "./NewPay.vue?vue&type=script&lang=js&"
export * from "./NewPay.vue?vue&type=script&lang=js&"
import style0 from "./NewPay.vue?vue&type=style&index=0&id=02343926&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02343926",
  null
  
)

export default component.exports